import Overview from "@wwdev/contentable/js/Overview";

class DownloadContentable extends Overview {

	$button;

	handleLoadMore(event) {
		event.preventDefault();
		let $button = $(event.currentTarget);
		this.$button = $button;
		let $scope = $button.closest(this.config.scope);
		this.request.setByKeyValue('page', $button.data('next-page'));
		this.request.setByKeyValue('group_id', $button.data('group-id'));
		this.type = 'load-more';
		this.reload($scope);
	}

	handleResponseLoadMore($scope, response) {
		let $group = this.$button.closest(this.config.group);

		$group.find(this.config.grid).append(response.grid);
		$group.find(this.config.pagination).html(response.pagination);
	}
}

export default new DownloadContentable({
	scope: '[data-download-contentable="scope"]',
	group: '[data-download-contentable="group"]',
});